import React from 'react'
import { AppBar, Box, Toolbar, IconButton } from '@mui/material'
import CalendarTodayOutlinedIcon from '@mui/icons-material/CalendarTodayOutlined'
import { IoChatbubblesOutline } from 'react-icons/io5'
import { AiOutlineSetting } from 'react-icons/ai'
import { UsuarioContext } from '../../../contexts/UsuarioContext'
import { Services } from '../../../services'
import RouterHook from '../../../contexts/RouterHook'
import { GoHome } from 'react-icons/go'
import { useLocation } from 'react-router-dom'

export default function BottomAppBar() {
  const serverRouter = RouterHook()
  const location = useLocation()
  const { userUCtx } = React.useContext(UsuarioContext)

  const [activeButton, setActiveButton] = React.useState('home')

  const handleButtonClick = button => {
    if (button === activeButton) return
    setActiveButton(button)
    if (button === 'home') {
      const label = Services.ReturnLabelURL(userUCtx.usuario.estado, userUCtx.usuario.cidade)
      serverRouter('home', label)
    } else if (button === 'calendar') {
      serverRouter('minha-agenda')
    } else if (button === 'chat') {
      serverRouter('chat', userUCtx.usuario.idusuario)
    } else if (button === 'account') {
      serverRouter('settings', userUCtx.usuario.idusuario)
    } else {
      console.error('Invalid button:', button)
    }
  }

  React.useEffect(() => {
    const path = location.pathname
    if (path.includes('cidade')) setActiveButton('home')
    else if (path.includes('conversas')) setActiveButton('chat')
    else if (path.includes('minha-agenda')) setActiveButton('calendar')
    else if (path.includes('configuracoes')) setActiveButton('account')
  }, [location.pathname])

  return (
    <AppBar
      position='fixed'
      sx={{
        zIndex: 1,
        top: 'auto',
        bottom: 0,
        backgroundColor: '#fff',
        boxShadow: '0px -1px 4px rgba(0, 0, 0, 0.2)',
      }}
    >
      <Toolbar
        sx={{
          display: 'flex',
          justifyContent: 'space-around',
          position: 'relative',
        }}
      >
        <IconButton
          onClick={() => handleButtonClick('home')}
          sx={{
            color: activeButton === 'home' ? '#ff6f00' : 'gray',
            position: 'relative',
          }}
        >
          <GoHome size={26} />
          {activeButton === 'home' && (
            <Box
              sx={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                height: '4px',
                backgroundColor: '#ff6f00',
              }}
            />
          )}
        </IconButton>
        <IconButton
          onClick={() => handleButtonClick('calendar')}
          sx={{
            color: activeButton === 'calendar' ? '#ff6f00' : 'gray',
            position: 'relative',
          }}
        >
          <CalendarTodayOutlinedIcon />
          {activeButton === 'calendar' && (
            <Box
              sx={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                height: '4px',
                backgroundColor: '#ff6f00',
              }}
            />
          )}
        </IconButton>
        <IconButton
          onClick={() => handleButtonClick('chat')}
          sx={{
            color: activeButton === 'chat' ? '#ff6f00' : 'gray',
            position: 'relative',
          }}
        >
          <IoChatbubblesOutline />
          {activeButton === 'chat' && (
            <Box
              sx={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                height: '4px',
                backgroundColor: '#ff6f00',
              }}
            />
          )}
        </IconButton>
        <IconButton
          onClick={() => handleButtonClick('account')}
          sx={{
            color: activeButton === 'account' ? '#ff6f00' : 'gray',
            position: 'relative',
          }}
        >
          <AiOutlineSetting />
          {activeButton === 'account' && (
            <Box
              sx={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                height: '4px',
                backgroundColor: '#ff6f00',
              }}
            />
          )}
        </IconButton>
      </Toolbar>
    </AppBar>
  )
}
